import CeChip from './CeChip';

export default CeChip;
